import { useEffect, useState } from "react";
import { BsFilePerson, BsList } from "react-icons/bs";
import { GrClose } from "react-icons/gr";
import { HiShoppingCart } from "react-icons/hi";
import Logo from "../../assets/logo.png";
import { useCart } from "../../hooks/useCart";
import CartDrawer from "./cart-drawer";

import Dialog from "@mui/material/Dialog";
import Menu from "@mui/material/Menu";

import { MdAccountCircle, MdLocationPin } from "react-icons/md";
import { TbChefHat } from "react-icons/tb";

import { GiBackwardTime } from "react-icons/gi";

import { FcGoogle } from "react-icons/fc";

import { FiSearch } from "react-icons/fi";

import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { MdKeyboardBackspace } from "react-icons/md";

import Drawer from "@mui/material/Drawer";

import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useLanguage } from "../../hooks/useLanguage";
import {
  POST_LOGOUT,
  POST_TO_CART,
  POST_USER_DATA,
  TOGGLE_DIALOG
} from "../../store/action";
import { EmailValidation } from "../functions/validateEmailPassword";
import "../styles/navbar.css";
import LanguageToggleButton from "./language-toggle-button";
import { openNotificationWithIcon } from "./notification-bar";

import { useGoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";

import Axios from "axios";
import { t } from "../../translations";
import { GET, POST } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress } from "@mui/material";
import jwt_decode from "jwt-decode";
import { clearAuthStorage, storeUserData } from "../../utils/authStorageUtils";
import { createLogger } from "../../utils/logger";
import { Aa } from "../functions/Aa";

const logger = createLogger("Navbar");
const Navbar = (props) => {
  const [open, setOpen] = useState(false);
  const [openCart, setOpenCart] = useState(false);
  // const [openDialog, setOpenDialog] = useState(false)
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpStep, setShowOtpStep] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [i_exist, setIexist] = useState("");

  const [load, setLoad] = useState(false);

  const [next, setNext] = useState(false);
  const [existing] = useState(false);

  const [errorLog, setErrorLog] = useState("");

  const [, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);

  const openDropdown = Boolean(anchorEl2);
  // const [openDropdown, _] = useState(false);

  const zip = useSelector((state) => state.selectedZip);

  const selectedWhen = useSelector((state) => state.selectedWhen);
  const openDialog = useSelector((state) => state.openDialog);

  // Use cart service for cart statistics
  const { getStats } = useCart();
  const cartStats = getStats();

  const setOpenDialog = (data) => {
    dispatch(toggle_dialog(data));
  };

  const userData = useSelector((state) => state.user);

  // Phase 1: Initialize language (common for both logged-in and non-logged-in users)
  // This ensures language is loaded from localStorage/browser before rendering
  const { selectedLang, changeLanguage } = useLanguage();

  const history = useHistory();

  const dispatch = useDispatch();

  const LogOutUser = () => {
    // Clear localStorage authentication data
    clearAuthStorage();
    logger.log("🔓 User logged out - cleared auth storage");
    
    // Dispatch Redux logout action
    dispatch(post_logout());
  };

  // Password validation function
  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasMinLength = password.length >= minLength;

    return {
      isValid:
        hasMinLength &&
        hasUpperCase &&
        hasLowerCase &&
        hasNumbers &&
        hasSpecialChar,
      requirements: {
        minLength: hasMinLength,
        hasUpperCase,
        hasLowerCase,
        hasNumbers,
        hasSpecialChar
      }
    };
  };

  // North American phone number validation regex:
  // Matches 10 digits where:
  // - Area code: first digit 2-9, followed by two digits
  // - Exchange code: first digit 2-9, followed by two digits
  // - Subscriber number: four digits
  // Example: 2345678901
  const NORTH_AMERICAN_PHONE_REGEX = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;

  const validatePhoneNumber = (phone) => {
    return NORTH_AMERICAN_PHONE_REGEX.test(phone);
  };

  // Send SMS OTP function
  const sendOtp = async () => {
    try {
      if (!phoneNumber) {
        return openNotificationWithIcon(
          "error",
          t("navbar.phone_enter", selectedLang)
        );
      }

      if (!validatePhoneNumber(phoneNumber)) {
        return openNotificationWithIcon(
          "error",
          "Please enter a valid North American phone number (10 digits)"
        );
      }

      setOtpLoading(true);
      const request_details = {
        type: POST,
        url: service_api,
        route: "user/send-user-otp",
        data: {
          email: email,
          phoneNumber: phoneNumber
        },
        token: null
      };

      await MakeRequestAsync(request_details);
      setOtpLoading(false);
      setShowOtpStep(true);
      openNotificationWithIcon("success", t("navbar.otp_sent", selectedLang));
    } catch (err) {
      setOtpLoading(false);
      setErrorLog(err?.response?.data?.message);
      openNotificationWithIcon(
        "error",
        err?.response?.data?.message ||
          t("navbar.otp_failed_send", selectedLang)
      );
    }
  };

  // Verify OTP function
  const verifyOtp = async () => {
    if (!otp) {
      return openNotificationWithIcon(
        "error",
        t("navbar.otp_enter_required", selectedLang)
      );
    }

    setOtpLoading(true);
    const request_details = {
      type: POST,
      url: service_api,
      route: "user/verify-user-otp",
      data: {
        email: email,
        phoneNumber: phoneNumber,
        otp: otp
      },
      token: null
    };

    try {
      const response = await MakeRequestAsync(request_details);
      setOtpLoading(false);
      setOpen(false);
      const decrypt = decryptSingleData(response?.data?.user);
      
      // Debug: Check OTP verification response
      logger.debug("🔑 OTP Verification Debug:", {
        hasUserData: !!response?.data?.user,
        hasAuthToken: !!response?.data?.auth_token,
        hasRefreshTokenInDecrypted: !!decrypt?.refresh_token,
        authTokenLength: response?.data?.auth_token?.length,
        decryptedTokenLength: decrypt?.refresh_token?.length
      });
      
      // Use separate auth_token if available, otherwise use token from encrypted data
      const finalUserData = {
        ...decrypt,
        refresh_token: response?.data?.auth_token || decrypt?.refresh_token
      };
      
      logger.debug("🔐 Final OTP User Data Being Stored:", {
        hasRefreshToken: !!finalUserData.refresh_token,
        refreshTokenValue: finalUserData.refresh_token,
        refreshTokenLength: finalUserData.refresh_token?.length,
        userId: finalUserData._id,
        email: finalUserData.email,
        finalUserDataKeys: Object.keys(finalUserData)
      });
      
      // Store in Redux
      post_user_data(finalUserData);
      
      // Store in localStorage for persistence
      storeUserData(finalUserData);
      setOpenDialog(false);
      // ✅ Better - OTP verification updates Redux state, no need for page reload
      // The user data update will trigger re-renders automatically
    } catch (err) {
      setOtpLoading(false);
      setErrorLog(err?.response?.data?.message);

      openNotificationWithIcon(
        "error",
        err?.response?.data?.message || t("navbar.otp_invalid", selectedLang)
      );
    }
  };

  useEffect(() => {
    getLatestUserData();
    if ((!props?.landing && !zip) || (!props?.landing && zip.length === 0)) {
      setAnchorEl(true);
    }
  }, []);

  const getLatestUserData = async () => {
    if (userData && userData?.refresh_token.length !== 0) {
      const request_details = {
        type: GET,
        url: service_api,
        route: `user/get-one/${userData?._id}`,
        data: null,
        token: userData?.refresh_token
      };

      try {
        const response = await MakeRequestAsync(request_details);
        return post_user_data(decryptSingleData(response.data.user));
      } catch (err) {
        logger.log(err);
        LogOutUser();
        // ✅ Better - Navigate to home instead of full page reload
        // This clears the current page state and provides fresh start
        history.push("/");
        
      }
    }
    return;
  };

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const post_to_cart = (data) => {
    dispatch(post_cart(data));
  };

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  // Reusable function to reset dialog state
  const resetDialogState = () => {
    setNext(false);
    setLoad(false);
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setShowPassword(false);
    setShowConfirmPassword(false);
    setFirstname("");
    setLastname("");
    setPhoneNumber("");
    setOtp("");
    setShowOtpStep(false);
    setOtpLoading(false);
    setIexist(false);
    setErrorLog("");
  };

  const handleEmailLogin = async () => {
    // Check if user entered phone number instead of email
    const isPhoneNumber = NORTH_AMERICAN_PHONE_REGEX.test(email);

    const request_details = {
      type: POST,
      url: service_api,
      route: "user/check-user-exists",
      data: {
        email: isPhoneNumber ? "" : email,
        phoneNumber: isPhoneNumber ? email : phoneNumber
      },
      token: null
    };

    try {
      const response = await MakeRequestAsync(request_details);
      if (response.data.exists) {
        // User exists, show password field for login
        setIexist(true);

        // If user was found by phone number, populate email field and set phone number
        if (response.data.user && response.data.user.email) {
          setEmail(response.data.user.email);
        }
        if (response.data.user && response.data.user.number) {
          setPhoneNumber(response.data.user.number);
        }

        return setNext(true);
      } else {
        // User doesn't exist, show signup form
        setIexist(false);
        return setNext(true);
      }
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        t("navbar.error_checking_user", selectedLang)
      );
    } finally {
      setLoad(false);
    }
  };

  const handlePasswordSignup = async () => {
    const request_details = {
      type: POST,
      url: service_api,
      route: "user/create-user",
      data: {
        email: email,
        password: password,
        firstname: firstname,
        lastname: lastname,
        number: phoneNumber
      },
      token: null
    };

    try {
      const response = await MakeRequestAsync(request_details);
      setOpen(false);
      const decrypt = decryptSingleData(response?.data?.user);
      post_user_data({
        ...decrypt
      });
      setOpenDialog(false);
      // ✅ Better - Password signup updates Redux state, no need for page reload
      // The user data update will trigger re-renders automatically
    } catch (err) {
      setErrorLog(err?.response?.data?.message);
      return openNotificationWithIcon("error", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const handlePasswordLogin = async () => {
    const request_details = {
      type: POST,
      url: service_api,
      route: "user/login-user",
      data: {
        email: email,
        password: password
      },
      token: null
    };

    try {
      const response = await MakeRequestAsync(request_details);
      setOpen(false);
      const decrypt = decryptSingleData(response?.data?.user);
      
      // Debug: Check password login response
      logger.log("🔑 Password Login Debug:", {
        hasUserData: !!response?.data?.user,
        hasAuthToken: !!response?.data?.auth_token,
        hasRefreshTokenInDecrypted: !!decrypt?.refresh_token,
        authTokenLength: response?.data?.auth_token?.length,
        decryptedTokenLength: decrypt?.refresh_token?.length
      });
      
      // Use separate auth_token if available, otherwise use token from encrypted data
      const finalUserData = {
        ...decrypt,
        refresh_token: response?.data?.auth_token || decrypt?.refresh_token
      };
      
      logger.log("🔐 Final Password User Data Being Stored:", {
        hasRefreshToken: !!finalUserData.refresh_token,
        refreshTokenValue: finalUserData.refresh_token,
        refreshTokenLength: finalUserData.refresh_token?.length,
        userId: finalUserData._id,
        email: finalUserData.email,
        finalUserDataKeys: Object.keys(finalUserData)
      });
      
      // Store in Redux
      post_user_data(finalUserData);
      
      // Store in localStorage for persistence
      storeUserData(finalUserData);
      setOpenDialog(false);
      // ✅ Better - Password login updates Redux state, no need for page reload
      // The user data update will trigger re-renders automatically
    } catch (err) {
      setErrorLog(err?.response?.data?.message);

      return openNotificationWithIcon("error", err?.response?.data?.message);
    } finally {
      setLoad(false);
    }
  };

  const googleLoginOneTap = useGoogleOneTapLogin({
    onSuccess: async (credentialResponse) => {
      logger.log(credentialResponse);
      // fetching userinfo can be done on the client or the server
      const userInfo = jwt_decode(credentialResponse.credential);

      logger.log(userInfo);

      if (!userInfo) {
        return setLoad(false);
      }

      // we now need to check user email exist or not and process

      const request_details = {
        type: POST,
        url: service_api,
        route: "user/login-oauth-user",
        data: {
          email: userInfo?.email,
          firstname: userInfo?.given_name,
          lastname: userInfo?.family_name
        },
        token: null
      };

      try {
        const response = await MakeRequestAsync(request_details);
        const decrypt = decryptSingleData(response?.data?.user);
        
        // Debug: Check OAuth response data
        logger.log("🔑 Google OAuth Login Debug:", {
          responseStatus: response?.status,
          hasUserData: !!response?.data?.user,
          hasAuthToken: !!response?.data?.auth_token,
          decryptedKeys: decrypt ? Object.keys(decrypt) : [],
          hasRefreshToken: !!decrypt?.refresh_token,
          tokenLength: decrypt?.refresh_token?.length,
          authTokenLength: response?.data?.auth_token?.length,
          userId: decrypt?._id,
          email: decrypt?.email,
          decryptedSample: decrypt
        });
        
        // Use separate auth_token if available, otherwise use token from encrypted data
        const finalUserData = {
          ...decrypt,
          refresh_token: response?.data?.auth_token || decrypt?.refresh_token
        };
        
        logger.log("🔐 Final OAuth User Data Being Stored (One-Tap):", {
          hasRefreshToken: !!finalUserData.refresh_token,
          refreshTokenValue: finalUserData.refresh_token,
          refreshTokenLength: finalUserData.refresh_token?.length,
          userId: finalUserData._id,
          email: finalUserData.email,
          finalUserDataKeys: Object.keys(finalUserData)
        });
        
        // Store in Redux
        post_user_data(finalUserData);
        
        // Store in localStorage for persistence
        storeUserData(finalUserData);
        // setOpen(false);
        setOpenDialog(false);
        // ✅ Better - Google OAuth login updates Redux state, no need for page reload
        // The user data update will trigger re-renders automatically
      } catch (err) {
        return openNotificationWithIcon(
          "error",
          t("navbar.error_login", selectedLang)
        );
      } finally {
        setLoad(false);
      }
    },
    onError: () => {
      setLoad(false);
      logger.log("Login Failed");
      return openNotificationWithIcon(
        "error",
        t("navbar.error_google", selectedLang)
      );
    }
  });

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // fetching userinfo can be done on the client or the server
        const userInfoResponse = await Axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
          }
        );
        const userInfo = userInfoResponse.data;

        if (!userInfo) {
          return setLoad(false);
        }

        logger.log(userInfo);

        // we now need to check user email exist or not and process

        const request_details = {
          type: POST,
          url: service_api,
          route: "user/login-oauth-user",
          data: {
            email: userInfo?.email,
            firstname: userInfo?.given_name,
            lastname: userInfo?.family_name
          },
          token: null
        };

        const response = await MakeRequestAsync(request_details);
        const decrypt = decryptSingleData(response?.data?.user);
        
        // Debug: Check OAuth response data
        logger.log("🔑 Google OAuth Manual Login Debug:", {
          responseStatus: response?.status,
          hasUserData: !!response?.data?.user,
          hasAuthToken: !!response?.data?.auth_token,
          decryptedKeys: decrypt ? Object.keys(decrypt) : [],
          hasRefreshToken: !!decrypt?.refresh_token,
          tokenLength: decrypt?.refresh_token?.length,
          authTokenLength: response?.data?.auth_token?.length,
          userId: decrypt?._id,
          email: decrypt?.email,
          decryptedSample: decrypt
        });
        
        // Use separate auth_token if available, otherwise use token from encrypted data
        const finalUserData = {
          ...decrypt,
          refresh_token: response?.data?.auth_token || decrypt?.refresh_token
        };
        
        logger.log("🔐 Final OAuth User Data Being Stored (Manual):", {
          hasRefreshToken: !!finalUserData.refresh_token,
          refreshTokenValue: finalUserData.refresh_token,
          refreshTokenLength: finalUserData.refresh_token?.length,
          userId: finalUserData._id,
          email: finalUserData.email,
          finalUserDataKeys: Object.keys(finalUserData)
        });
        
        // Store in Redux
        post_user_data(finalUserData);
        
        // Store in localStorage for persistence
        storeUserData(finalUserData);
        setOpen(false);
        setOpenDialog(false);
        // ✅ Better - Google OAuth login updates Redux state, no need for page reload
        // The user data update will trigger re-renders automatically
      } catch (err) {
        return openNotificationWithIcon(
          "error",
          t("navbar.error_login", selectedLang)
        );
      } finally {
        setLoad(false);
      }
    },
    onError: () => {
      setLoad(false);
      logger.log("Login Failed");
      return openNotificationWithIcon(
        "error",
        t("navbar.error_google", selectedLang)
      );
    }
  });

  return (
    <div className="navbar-block">
      <div className="navbar">
        <div className="navbar-logo">
          <img
            src={Logo}
            alt="Logo"
            onClick={() => {
              return history.push("/");
            }}
          />
          <span className="site-name">Pani</span>
        </div>

        <div className="navbar-links">
          {!props?.landing && (
            <div className="nav-link-input">
              <FiSearch
                size={30}
                color={"gray"}
                style={{
                  marginLeft: 5
                }}
              />
              <input
                placeholder={props?.placeholder}
                value={props?.textValue}
                onChange={(e) => {
                  props?.onSearch(e.target.value);
                }}
              />
            </div>
          )}
          {/* <Link to="/our-story" className="nav-link">
            {t("navbar.history", selectedLang)}
          </Link> */}
          {userData?.chef === false && userData?.restaurant === false && (
            <Link to="/become-a-chef" className="nav-link">
              {t("navbar.chef", selectedLang)}
            </Link>
          )}
          {(userData?.chef === true || userData?.restaurant === true) && (
            <Link to="/chef/iam-a-chef/home" className="nav-link">
              {t("navbar.dashboard_chef", selectedLang)}
            </Link>
          )}
          {!userData ? (
            <>
              {/* Phase 2: Non-logged-in user specific UI */}
              <button
                className="signin"
                onClick={() => {
                  setOpenDialog(true);
                }}
              >
                {t("navbar.login", selectedLang)}
              </button>
              <button
                className="signup"
                onClick={() => {
                  setOpenDialog(true);
                }}
              >
                {t("navbar.register", selectedLang)}
              </button>
              {/* Language toggle for non-logged-in users */}
              <LanguageToggleButton
                style={{ marginLeft: "10px", fontSize: "12px" }}
              />
            </>
          ) : (
            <>
              <button
                className="cart"
                onClick={() => {
                  setOpenCart(true);
                }}
              >
                <HiShoppingCart size={20} />
                <div className="number-order">
                  <p>{cartStats.itemCount}</p>
                </div>
              </button>
              <button className="cart cart-profile" onClick={handleClick2}>
                <BsFilePerson size={20} />
                <p> {t("navbar.profile", selectedLang)}</p>
              </button>
              {/* Language toggle for logged-in users */}
              <LanguageToggleButton
                style={{ marginLeft: "10px", fontSize: "12px" }}
              />
              {openDropdown && <div className="dropdown-menu"></div>}
            </>
          )}
        </div>
        <div
          className="drawer-mobile-icon"
          onClick={() => {
            setOpen(true);
          }}
        >
          <BsList size={30} />
          <button
            className="cart"
            style={{
              width: 20,
              height: 20,
              marginLeft: 0
            }}
          >
            <p>{cartStats.itemCount}</p>
          </button>
        </div>
      </div>
      <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
        <div className="navbar-mobile">
          <span>
            <GrClose
              size={30}
              onClick={() => {
                setOpen(false);
              }}
            />
          </span>
          <div className="drawer-item">
            <Link to="/our-story" className="nav-link">
              {t("navbar.history", selectedLang)}
            </Link>
          </div>
          <div className="drawer-item">
            {userData && userData?.chef === false && (
              <Link to="/become-a-chef" className="nav-link">
                {t("navbar.chef", selectedLang)}
              </Link>
            )}
            {userData &&
              (userData?.chef === true || userData?.restaurant === true) && (
                <Link to="/chef/iam-a-chef/home" className="nav-link">
                  {t("navbar.dashboard_chef", selectedLang)}
                </Link>
              )}
          </div>
          <div className="drawer-item">
            {!userData ? (
              <>
                {/* Phase 2: Non-logged-in user specific UI in mobile drawer */}
                <button
                  className="signin"
                  onClick={() => {
                    setOpenDialog(true);
                  }}
                >
                  {t("navbar.login", selectedLang)}
                </button>
                <button
                  className="signup"
                  onClick={() => {
                    setOpenDialog(true);
                  }}
                >
                  {t("navbar.register", selectedLang)}
                </button>
                {/* Language toggle for non-logged-in users in mobile */}
                <LanguageToggleButton
                  style={{
                    marginLeft: 0,
                    marginTop: 10,
                    width: 120,
                    fontSize: "12px"
                  }}
                />
              </>
            ) : (
              <div style={{}}>
                <button
                  className="cart"
                  style={{
                    width: 120,
                    marginLeft: 0
                  }}
                  onClick={() => {
                    setOpenCart(true);
                  }}
                >
                  <HiShoppingCart size={20} />
                  <div className="number-order">
                    <p>{cartStats.itemCount}</p>
                  </div>
                </button>
                <button
                  className="cart cart-profile"
                  style={{
                    marginLeft: 0,
                    marginTop: 20,
                    width: 120
                  }}
                  onClick={handleClick2}
                >
                  <BsFilePerson size={20} />
                  <p> {t("navbar.profile", selectedLang)}</p>
                </button>
                {/* Language toggle for logged-in users in mobile */}
                <LanguageToggleButton
                  style={{
                    marginLeft: 0,
                    marginTop: 10,
                    width: 120,
                    fontSize: "12px"
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Drawer>

      {/* Cart Drawer Component */}
      <CartDrawer
        open={openCart}
        onClose={() => setOpenCart(false)}
        onUpdateCart={post_to_cart}
      />
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl2}
        open={openDropdown}
        onClose={handleClose2}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        style={{}}
      >
        <div
          style={{
            width: 350,
            height: 350,
            marginTop: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: "#cecece",
                alignSelf: "center"
              }}
            ></div>
            <p
              style={{
                fontSize: 16,
                fontWeight: "500",
                textAlign: "center"
              }}
            >
              {Aa(userData?.firstname) + " " + Aa(userData?.lastname)}
            </p>
            <p
              style={{
                fontSize: 15,
                fontWeight: "500",
                textAlign: "center",
                marginTop: -15
              }}
            >
              {userData?.email}
            </p>
          </div>
          <hr />
          <div
            style={{
              width: "95%",
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            {[
              {
                title: t("navbar.home", selectedLang),
                icon: <TbChefHat size={22.5} />,
                returnFunction: () => {
                  return history.push(`/explore/chef?date=${selectedWhen}`);
                }
              },
              {
                title: t("navbar.profile", selectedLang),
                icon: <MdAccountCircle size={22.5} />,
                returnFunction: () => {
                  return history.push("/user/profile");
                }
              },
              {
                title: t("navbar.orders", selectedLang),
                icon: <GiBackwardTime size={22.5} />,
                returnFunction: () => {
                  return history.push("/user/orders");
                }
              },
              {
                title: t("navbar.delivery_address", selectedLang),
                icon: <MdLocationPin size={22.5} />,
                returnFunction: () => {
                  return history.push("/user/profile");
                }
              }
            ].map((item, index) => (
              <div
                key={index}
                className="item-profil-user"
                onClick={() => {
                  item?.returnFunction();
                }}
              >
                {item?.icon} {item.title}
              </div>
            ))}
          </div>
          <hr />
          <div
            className="btn-get-started"
            style={{
              backgroundColor: "#ff114d",
              width: "90%"
            }}
            onClick={() => {
              LogOutUser();
              // ✅ Better - Navigate to home instead of full page reload
              // This provides a clean slate without the jarring reload
              history.push("/");
            }}
          >
            {t("navbar.log_out", selectedLang)}
          </div>
        </div>
      </Menu>

      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          resetDialogState();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="log-in-up" style={{}}>
          <div className="log-in-up-title">
            {next && (
              <MdKeyboardBackspace
                size={30}
                onClick={() => {
                  setNext(false);
                }}
              />
            )}
            {!next && (
              <GrClose
                size={20}
                onClick={() => {
                  setOpenDialog(false);
                  resetDialogState();
                }}
              />
            )}
            <span>
              {!next && t("navbar.create_connect_account", selectedLang)}
              {next && !i_exist && t("navbar.create_account", selectedLang)}
              {next && i_exist && t("navbar.signin_text", selectedLang)}
            </span>
          </div>
          {!EmailValidation(email) &&
            email.length > 5 &&
            !NORTH_AMERICAN_PHONE_REGEX.test(email) && (
              <span
                style={{
                  fontSize: 14,
                  margin: 10,
                  color: "red"
                }}
              >
                {t("navbar.wrong_email", selectedLang)}
              </span>
            )}

          {userData === null && googleLoginOneTap}

          {!next && (
            <div className="log-in-up-menu">
              <h2> {t("navbar.welcome_pani", selectedLang)}</h2>

              {[
                {
                  icon: <FcGoogle size={25} />,
                  text: t("navbar.signup_google", selectedLang),
                  fn: () => {
                    setLoad(true);
                    googleLogin();
                  }
                }
              ].map((item) => (
                <div
                  className="log-in-up-item"
                  key={item.text}
                  onClick={() => {
                    if (load) {
                      return;
                    }
                    item?.fn();
                  }}
                >
                  {item.icon}
                  <span>{item.text}</span>
                </div>
              ))}
              <input
                placeholder={
                  t("navbar.signup_placeholder_email", selectedLang) +
                  " or " +
                  t("navbar.phone_number", selectedLang)
                }
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                value={email}
                type="text"
              />
              <span
                className="btn-email"
                onClick={() => {
                  const isPhoneNumber = NORTH_AMERICAN_PHONE_REGEX.test(email);
                  if (!EmailValidation(email) && !isPhoneNumber) {
                    openNotificationWithIcon(
                      "error",
                      t("navbar.wrong_email_notification", selectedLang)
                    );
                    return;
                  }
                  if (load) {
                    return;
                  }
                  // supposed to make an api call to check if this user exist or not,
                  // this line is to enable input in case user exist
                  // setExisting(true);
                  setLoad(true);
                  handleEmailLogin();
                  // setNext(true);
                }}
              >
                {load && <CircularProgress />}
                {!load && t("navbar.continue", selectedLang)}
              </span>
            </div>
          )}
          {/* this is frontend for non-existing user to access via e-mail */}
          {next === true && i_exist && (
            <div>
              <p
                style={{
                  fontSize: 18,
                  margin: 10
                }}
              >
                {t("navbar.enter_password_signin", selectedLang)}
              </p>

              <div style={{ display: "flex", gap: "10px", margin: "10px" }}>
                <button
                  onClick={() => setShowOtpStep(false)}
                  style={{
                    flex: 1,
                    padding: "10px",
                    backgroundColor: showOtpStep ? "#f0f0f0" : "#ff114d",
                    color: showOtpStep ? "#333" : "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer"
                  }}
                >
                  {t("navbar.password_login", selectedLang)}
                </button>
                <button
                  onClick={() => {
                    if (!showOtpStep) {
                      // First click - show phone number input
                      setShowOtpStep(true);
                      return;
                    }
                    // Second click - send OTP
                    if (!phoneNumber) {
                      openNotificationWithIcon(
                        "error",
                        t("navbar.phone_required", selectedLang)
                      );
                      return;
                    }
                    if (!validatePhoneNumber(phoneNumber)) {
                      openNotificationWithIcon(
                        "error",
                        "Please enter a valid North American phone number (10 digits)"
                      );
                      return;
                    }
                    sendOtp();
                  }}
                  style={{
                    flex: 1,
                    padding: "10px",
                    backgroundColor: showOtpStep ? "#ff114d" : "#f0f0f0",
                    color: showOtpStep ? "white" : "#333",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer"
                  }}
                >
                  {showOtpStep
                    ? t("navbar.send_otp", selectedLang)
                    : t("navbar.sms_login", selectedLang)}
                </button>
              </div>
            </div>
          )}

          {next === true && !i_exist && (
            <p
              style={{
                fontSize: 18,
                margin: 10
              }}
            >
              {t("navbar.enter_password_details_signup", selectedLang)}
            </p>
          )}

          {next === true && (
            <p
              style={{
                fontSize: 18,
                margin: 10,
                color: "red"
              }}
            >
              {errorLog}
            </p>
          )}

          {/* Password requirements display for signup */}
          {next === true && !i_exist && password.length > 0 && (
            <div style={{ margin: "10px", fontSize: "14px" }}>
              <p style={{ margin: "5px 0", fontWeight: "bold" }}>
                {t("navbar.password_requirements", selectedLang)}:
              </p>
              <div style={{ marginLeft: "10px" }}>
                {(() => {
                  const validation = validatePassword(password);
                  return (
                    <>
                      <div
                        style={{
                          color: validation.requirements.minLength
                            ? "green"
                            : "red"
                        }}
                      >
                        ✓ {t("navbar.password_req_min_length", selectedLang)}
                      </div>
                      <div
                        style={{
                          color: validation.requirements.hasUpperCase
                            ? "green"
                            : "red"
                        }}
                      >
                        ✓ {t("navbar.password_req_uppercase", selectedLang)}
                      </div>
                      <div
                        style={{
                          color: validation.requirements.hasLowerCase
                            ? "green"
                            : "red"
                        }}
                      >
                        ✓ {t("navbar.password_req_lowercase", selectedLang)}
                      </div>
                      <div
                        style={{
                          color: validation.requirements.hasNumbers
                            ? "green"
                            : "red"
                        }}
                      >
                        ✓ {t("navbar.password_req_numbers", selectedLang)}
                      </div>
                      <div
                        style={{
                          color: validation.requirements.hasSpecialChar
                            ? "green"
                            : "red"
                        }}
                      >
                        ✓ {t("navbar.password_req_special", selectedLang)}
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          )}

          {/* OTP Verification Step */}
          {showOtpStep && (
            <div className="log-in-up-menu">
              <h2>{t("navbar.otp_verify", selectedLang)}</h2>
              <p style={{ fontSize: "14px", margin: "10px 0", color: "#666" }}>
                {t("navbar.otp_sent_message", selectedLang)} {phoneNumber}
              </p>
              <input
                placeholder={t("navbar.otp_enter", selectedLang)}
                value={otp}
                onChange={(e) => {
                  // Only allow 6 digits
                  const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                  setOtp(value);
                }}
                type="text"
                maxLength="6"
                style={{
                  width: "100%",
                  padding: "10px",
                  marginBottom: "10px",
                  textAlign: "center",
                  fontSize: "18px",
                  letterSpacing: "2px"
                }}
              />
              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button
                  className="btn-email"
                  onClick={verifyOtp}
                  disabled={otpLoading || otp.length !== 6}
                  style={{
                    flex: 1,
                    opacity: otpLoading || otp.length !== 6 ? 0.6 : 1,
                    cursor:
                      otpLoading || otp.length !== 6 ? "not-allowed" : "pointer"
                  }}
                >
                  {otpLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    t("navbar.verify_otp", selectedLang)
                  )}
                </button>
                <button
                  className="btn-email"
                  onClick={sendOtp}
                  disabled={otpLoading}
                  style={{
                    flex: 1,
                    opacity: otpLoading ? 0.6 : 1,
                    cursor: otpLoading ? "not-allowed" : "pointer",
                    backgroundColor: "#f0f0f0",
                    color: "#333"
                  }}
                >
                  {t("navbar.otp_resend", selectedLang)}
                </button>
              </div>
              <button
                onClick={() => setShowOtpStep(false)}
                style={{
                  background: "none",
                  border: "none",
                  color: "#666",
                  cursor: "pointer",
                  marginTop: "10px",
                  textDecoration: "underline"
                }}
              >
                {t("navbar.back_to_form", selectedLang)}
              </button>
            </div>
          )}

          {next && !existing && !showOtpStep && (
            <div className="log-in-up-menu">
              {!EmailValidation(email) && email.length > 5 && (
                <span
                  style={{
                    fontSize: 14,
                    marginTop: -20,
                    color: "red"
                  }}
                >
                  {t("navbar.wrong_email", selectedLang)}
                </span>
              )}
              {[
                {
                  placeholder: t(
                    "navbar.signup_placeholder_email",
                    selectedLang
                  ),
                  value: email,
                  type: "email",
                  onChange: setEmail,
                  key: "email",
                  shown: true
                },
                {
                  placeholder: t("navbar.password_placeholder", selectedLang),
                  value: password,
                  type: showPassword ? "text" : "password",
                  onChange: setPassword,
                  key: "password",
                  shown: true,
                  isPassword: true
                },
                {
                  placeholder: t(
                    "navbar.confirm_password_placeholder",
                    selectedLang
                  ),
                  value: confirmPassword,
                  type: showConfirmPassword ? "text" : "password",
                  onChange: setConfirmPassword,
                  key: "confirmPassword",
                  shown: !i_exist, // Only show for new users (signup)
                  isPassword: true
                },
                {
                  placeholder: t("navbar.phone_number", selectedLang),
                  value: phoneNumber,
                  type: "tel",
                  onChange: setPhoneNumber,
                  key: "phoneNumber",
                  shown: !i_exist || showOtpStep // Show for signup or when SMS login is selected
                },
                {
                  placeholder: t(
                    "navbar.signup_placeholder_firstname",
                    selectedLang
                  ),
                  value: firstname,
                  type: "text",
                  onChange: setFirstname,
                  key: "firstname",
                  shown: !i_exist // Only show for new users (signup)
                },
                {
                  placeholder: t(
                    "navbar.signup_placeholder_lastname",
                    selectedLang
                  ),
                  value: lastname,
                  type: "text",
                  onChange: setLastname,
                  key: "lastname",
                  shown: !i_exist // Only show for new users (signup)
                }
              ].map((item) => (
                <div
                  key={item.key}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative"
                  }}
                >
                  {item.shown && (
                    <>
                      <input
                        autoComplete="off"
                        placeholder={item.placeholder}
                        onChange={(e) => {
                          item?.onChange(e.target.value);
                        }}
                        value={item?.value}
                        type={item?.type}
                        style={{
                          width: "100%",
                          paddingRight: item.isPassword ? "40px" : "10px"
                        }}
                      />
                      {item.isPassword && (
                        <button
                          type="button"
                          onClick={() => {
                            if (item.key === "password") {
                              setShowPassword(!showPassword);
                            } else if (item.key === "confirmPassword") {
                              setShowConfirmPassword(!showConfirmPassword);
                            }
                          }}
                          style={{
                            position: "absolute",
                            right: "10px",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "5px"
                          }}
                        >
                          {(
                            item.key === "password"
                              ? showPassword
                              : showConfirmPassword
                          ) ? (
                            <AiFillEyeInvisible size={20} />
                          ) : (
                            <AiFillEye size={20} />
                          )}
                        </button>
                      )}
                    </>
                  )}
                </div>
              ))}
              <span
                className="btn-email"
                onClick={() => {
                  if (!EmailValidation(email)) {
                    openNotificationWithIcon(
                      "error",
                      t("navbar.wrong_email_notification", selectedLang)
                    );
                    setErrorLog(
                      t("navbar.wrong_email_notification", selectedLang)
                    );
                    return;
                  }

                  if (i_exist) {
                    // For existing users, check if they want SMS login or password login
                    if (showOtpStep) {
                      // SMS login - phone number should be filled
                      if (phoneNumber.length === 0) {
                        setErrorLog(t("navbar.phone_required", selectedLang));
                        return openNotificationWithIcon(
                          "error",
                          t("navbar.phone_required", selectedLang)
                        );
                      }

                      if (!validatePhoneNumber(phoneNumber)) {
                        setErrorLog(
                          "Please enter a valid North American phone number (10 digits)"
                        );
                        return openNotificationWithIcon(
                          "error",
                          "Please enter a valid North American phone number (10 digits)"
                        );
                      }
                      // OTP verification is handled in the OTP step
                      return;
                    } else {
                      // Password login
                      if (password.length < 8) {
                        setErrorLog(
                          t("navbar.password_min_length_error", selectedLang)
                        );
                        return openNotificationWithIcon(
                          "warning",
                          t("navbar.password_min_length_error", selectedLang)
                        );
                      }
                      setLoad(true);
                      handlePasswordLogin();
                    }
                  } else {
                    // For new users, password signup
                    const passwordValidation = validatePassword(password);
                    if (!passwordValidation.isValid) {
                      setErrorLog(
                        t("navbar.password_requirements", selectedLang)
                      );
                      return openNotificationWithIcon(
                        "warning",
                        t("navbar.password_requirements", selectedLang)
                      );
                    }

                    if (confirmPassword.length === 0) {
                      setErrorLog(
                        t("navbar.password_confirm_required", selectedLang)
                      );
                      return openNotificationWithIcon(
                        "error",
                        t("navbar.password_confirm_required", selectedLang)
                      );
                    }

                    if (password !== confirmPassword) {
                      setErrorLog(
                        t("navbar.passwords_not_match", selectedLang)
                      );
                      return openNotificationWithIcon(
                        "error",
                        t("navbar.passwords_not_match", selectedLang)
                      );
                    }

                    if (firstname.length === 0 || lastname.length === 0) {
                      setErrorLog(
                        t(
                          "navbar.signup_firstname_lastname_notification",
                          selectedLang
                        )
                      );
                      openNotificationWithIcon(
                        "error",
                        t(
                          "navbar.signup_firstname_lastname_notification",
                          selectedLang
                        )
                      );
                      return;
                    }

                    if (phoneNumber.length === 0) {
                      setErrorLog(t("navbar.phone_required", selectedLang));
                      openNotificationWithIcon(
                        "error",
                        t("navbar.phone_required", selectedLang)
                      );
                      return;
                    }

                    if (!validatePhoneNumber(phoneNumber)) {
                      setErrorLog(
                        "Please enter a valid North American phone number (10 digits)"
                      );
                      openNotificationWithIcon(
                        "error",
                        "Please enter a valid North American phone number (10 digits)"
                      );
                      return;
                    }

                    // For signup, create the user directly (no OTP needed for password signup)
                    setLoad(true);
                    handlePasswordSignup();
                  }
                }}
              >
                {!i_exist && !load && t("navbar.signup_text", selectedLang)}
                {i_exist &&
                  !load &&
                  !showOtpStep &&
                  t("navbar.signin_text", selectedLang)}
                {i_exist &&
                  !load &&
                  showOtpStep &&
                  t("navbar.send_otp", selectedLang)}
                {load && <CircularProgress />}
              </span>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default Navbar;

const post_cart = (data) => ({
  type: POST_TO_CART,
  data: data
});

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});

const toggle_dialog = (data) => ({
  type: TOGGLE_DIALOG,
  data: data
});

const post_logout = () => ({
  type: POST_LOGOUT,
  data: null
});
